module.exports = __webpack_public_path__ + "static/media/it.3d829421.jpg";